import {del, post} from '../../utils/apiRequest';

type TextData = Editor.TextData
type Translatable = Editor.Translatable
type TranslatableMap = Editor.TranslatableMap

const apiPath = '/api/v1/translation/trs'
const singleTrPath = '/api/v1/translation/tr'

export type TextAPITranslatable = {
  locale: string
  text: string
  tuuid: string
  versionChecksum: string
}

export const fetchTR1s = async (trIds: string[], locale: string, projectId?: string): Promise<TranslatableMap> => {
  if (trIds.length === 0) return {}

  // NOTE: use POST variant of API endpoint to avoid URL length restrictions
  const trs = await post(`${apiPath}/${locale}`, {
    fields: ['text', 'tuuid', 'versionChecksum'],
    trIds,
    // Scope by context when available (server can infer type from id)
    ...(projectId ? { contextId: projectId } : {}),
  }) as TextAPITranslatable[]

  // return targetId->Translatable map
  return trs.reduce(
    (map, {text, tuuid: id, versionChecksum: checksum}) => {
      const translatable: TextData = {checksum, id, locale, text}
      map[id] = translatable
      return map
    },
    {} as TranslatableMap
  )
}

export const saveTR1s = async (translatables: Translatable[]) => {
  if (translatables.length === 0) return

  const data = translatables.map(translatable => {
    const {checksum: versionChecksum, id: tuuid, locale, text} = translatable as TextData
    const data: TextAPITranslatable = {locale, text, tuuid, versionChecksum}
    return data
  })

  return post(apiPath, data)
}

export const deleteTR = async (
  tuuid: string,
  locale: string,
  opts?: { contextId?: string; contextType?: string }
) => {
  const params = new URLSearchParams()
  if (opts?.contextId) params.set('contextId', opts.contextId)
  if (opts?.contextType) params.set('contextType', opts.contextType)
  const query = params.toString()
  const url = `${singleTrPath}/${encodeURIComponent(tuuid)}/${encodeURIComponent(locale)}${query ? `?${query}` : ''}`
  return del(url)
}
